
import React, { useState, useEffect } from "react";
import "./drawer.scss";
import Button from "components/Button/index";
import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";

const Drawer = ({
  title = "",
  mockClass,
  isVisible,
  heading = "",
  closable = true,
  handleCancel = () => { },
  handleSave = () => { },
  children,
  height,
  showHeader = true,
  showFooter = true,
  showCross = true,
  isDisabled = false,
  submitBtnText = "Save",
  submitBtnColor = "violet",
  closeBtnColor = "white",
  closeBtnTxt = "Cancel",
  leftButtonWith = "40%",
  rightButtonWith = "40%",
  customHeader = false,
  description = ""
}) => {
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    const handleOutsideClick = (e) => {
      const drawerElement = document.querySelector(".drawer");
      if (drawerElement && !drawerElement.contains(e.target)) {
        handleCancel();
      }
    };

    if (closable) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.body.style.overflow = "auto";
      if (closable) {
        document.removeEventListener("mousedown", handleOutsideClick);
      }
    };
  }, [closable, handleCancel]);

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => {
        setIsDrawerVisible(true);
      }, 10);
    } else {
      setTimeout(() => {
        setIsDrawerVisible(false);
      }, 250);
    }
  }, [isVisible]);

  return (
    <>
      {isVisible && <div className="overlay" onClick={closable ? handleCancel : undefined}></div>}
      <div
        className={`drawer ${isDrawerVisible ? "visible" : ""} ${mockClass}`}
        style={{ height: height }}
      >
        <div className="drawerContent" onClick={(e) => e.stopPropagation()}>
          {showHeader && (
            <div className="drawerHeader">
              <p>{heading}</p>
              {showCross && (
                <div className="cross" onClick={handleCancel}>
                  <GetActionIcon type="cross" color="var(--text-grey-strong)" />
                </div>
              )}
            </div>
          )}
          {customHeader && (
            <div className="header">
              <p className="heading">{heading}</p>
              <p className="desc">{description}</p>
              {showCross && (
                <div className="close" onClick={handleCancel}>
                  <GetActionIcon type="cross" color="var(--text-grey-strong)" />
                </div>
              )}
            </div>
          )}
          {children}

          {showFooter && (
            <div className="drawerFooterContainer">
              <Button
                type={closeBtnColor}
                width={leftButtonWith}
                title={closeBtnTxt}
                onClick={handleCancel}
              />
              <Button
                disabled={isDisabled}
                type={submitBtnColor}
                width={rightButtonWith}
                title={submitBtnText}
                onClick={handleSave}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Drawer;
